<app-header *ngIf="showHeader"></app-header>
<app-header-spinea *ngIf="showHeaderSpinea"></app-header-spinea>
<app-home></app-home>
<app-footer *ngIf="showFooter"></app-footer>
<app-footer-spinea *ngIf="showFooterSpinea"></app-footer-spinea>
